export default "__VITE_ASSET__C456Neo___"